import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import url from "url/index";
import { setServiceError } from "stores/settings";
import { setHostname } from "utils/hostname";
import { setHeaders } from "utils/credential";
import { sentEmail } from "./slice";
import { STORAGE_AUTH_TOKEN } from "../../constants/variables";
import {
  RecoveryEmailRequestType,
  RecoveryEmailResponseType,
  RecoveryPasswordRequestType,
  RecoveryPasswordResponseType,
} from "../../types/Recovery";
import { setLocalStorageItem } from "../../utils/localStorage";

export const recoveryApi = createApi({
  reducerPath: "recoveryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: setHostname(),
    prepareHeaders: setHeaders,
  }),
  endpoints: (build) => ({
    recovery: build.mutation<
      RecoveryEmailResponseType,
      RecoveryEmailRequestType
    >({
      query: (request: RecoveryEmailRequestType) => ({
        url: url.config.api.auth.recovery,
        method: "POST",
        body: request,
      }),
      async onQueryStarted(
        request: RecoveryEmailRequestType,
        { dispatch, queryFulfilled },
      ) {
        try {
          const { data } = await queryFulfilled;
          if (data.statusCode === 200) {
            dispatch(sentEmail());
          }
          if (data.statusCode >= 500) {
            setServiceError(true);
          }
        } catch (error: any) {
          if (error.statusCode >= 500) {
            setServiceError(true);
          }
        }
      },
    }),
    recoveryPassword: build.mutation<
      RecoveryPasswordResponseType,
      RecoveryPasswordRequestType
    >({
      query: (request: RecoveryPasswordRequestType) => ({
        url: url.config.api.auth.passwordReset,
        method: "PATCH",
        body: request,
      }),
      async onQueryStarted(
        request: RecoveryPasswordRequestType,
        { dispatch, queryFulfilled },
      ) {
        try {
          const { data } = await queryFulfilled;
          if (data.statusCode === 200) {
            dispatch(sentEmail());
          }
          if (data.statusCode >= 500) {
            setServiceError(true);
          }
          setLocalStorageItem(STORAGE_AUTH_TOKEN, data.authToken);
        } catch (error: any) {
          if (error.statusCode >= 500) {
            setServiceError(true);
          }
        }
      },
    }),
  }),
});
